import YouTube from 'react-youtube';

const YouTubeShort = ({ videoId }) => {
  const opts = {
    height: '560',
    width: '315',
    playerVars: {
      autoplay: 0,
    },
  };

  return <YouTube className="youtube-short" videoId={videoId} opts={opts} />;
};

const VideoCard = ({ video, onRemove, fullHeight }) => {
    const isYouTubeShort = video.videoUrl.includes('youtube.com/shorts/');
    const isTikTok = video.videoUrl.toLowerCase().includes('tiktok');
    const isShort = isYouTubeShort || isTikTok;
    return (
        <div className={`video-card ${isShort ? 'short' : ''}`} style={fullHeight ? {height: 'auto'} : undefined}>
            {onRemove ? (
                <button className="video-remove" onClick={() => onRemove(video.videoUrl)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <div className="w-100">
                {video.videoUrl.toLowerCase().includes('youtu') ? (
                    isYouTubeShort ? <YouTubeShort videoId={getVideoDetails(video.videoUrl)} /> : (<YouTube videoId={getVideoDetails(video.videoUrl)}
                        className={"youtube-video" + (video.videoUrl.toLowerCase().includes('shorts') ? " youtube-shorts" : "")} />)
                ) : isTikTok ? (
                    <iframe style={{width: '80%', aspectRatio: '9/16', margin: '0 10% 0', border: 'none'}} src={`https://www.tiktok.com/player/v1/${extractTikTokId(video.videoUrl)}?fullscreen_button=1`} />
                ) : (
                    <video controls src={video.videoUrl} style={{width: '100%', maxWidth: 'unset', height: 'auto'}} />
                )}
            </div>
            {!!video.title && (
                <div className="w-100">
                    {video.title}
                </div>
            )}
        </div>
    );
}

function getVideoDetails(url) {
  const ytRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(ytRegExp);
  const videoId = match && match[2].length === 11 ? match[2] : null;

  return videoId;
}

function extractTikTokId(url) {
  const match = url.match(/\/video\/(\d+)/);
  return match ? match[1] : '';
}

export default VideoCard;